<template>
  <div class="privacy">
    <div class="head">
      <van-icon name="arrow-left" class="black_arrow" @click="closeContract"/>
      <div class="title">培训服务协议</div>
    </div>
    <div class="privacy-box">
    
      <div>
        
      </div>
      <!-- <h1 style="position:relative"><van-icon name="arrow-left" class="backIcon" @click="closeProtocol"/>个人信息及隐私保护政策</h1> -->
      <h2 class="yinyan">人工智能应用管理师（初级）<br />职业能力等级评价项目培训协议</h2>
      <br />
      <p>合同编号：</p>
      <p>甲  方（培训方）：北京伟东凌鸿教育科技有限公司</p>
      <p>乙  方（学员方）：</p>
      <p style="text-indent:1.5rem">学员经向甲方咨询，并对甲方提供的课程之学习方法及其他事项进行了全面的了解及认可后，自愿与甲方签订本课程培训协议。甲方将向学员提供在线视频及直播课程等形式的教学服务。
</p>
        <br />
      <!-- <h2>一、培训课程内容介绍</h2> -->
      <p class="title2">一、培训课程内容介绍</p>
      <p>
        1.项目及培训课程名称：人工智能应用管理师（初级）
        <br />2.证书名称：人工智能应用管理师（初级）
        <br />3.培训课程时间：45天（自然日）
        <br />4.培训课程课时：60课时（45分钟/课时）
        <br />5.培训课程科目：Python编程基础、数据采集与预处理、数据标注工程、AI系统部署与运维、AI开放平台应用
        <br />6.培训课程及考试报名费用：共计 3200元（大写：叁仟贰佰元整）。
        <br />具体明细：课时费 2400元，平台使用费800元
      </p>
      <br />
      <p class="title2">二、课时使用和消耗的说明</p>
      <p>
        1.课程周期为45天（自然日）；
        <br />2.课时消耗的计算方式为，付款45天内（包含45天）按使用天数进行等比计算；
        <br />3.平台使用费：自账号开通之日起，平台费用视为已消耗；
        <br />4.考试报名费：成功报考即时消耗（报考未参加，参加未通过均视为消耗不予退还）。
        <br />5.若达到或超过45天仍未取得人工智能应用管理师（初级）证书，则该课程学习时间至多可延长至一年。
      </p>
      <br />
      <p class="title2">三、退费说明</p>
      <p>
        学员应全程完成培训，因自身原因单方中止培训的，按如下规则办理退费申请：
        <br />1.学员报名培训课程并缴费成功且尚未实际消耗课时的七日内，扣除平台使用费800元，可退回剩余全部培训课时费；
        <br />2.学员报名7日后30日（不含30日）内申请退费，扣除平台使用费800元，可退回未消耗的课时费用（课时消耗参见“课时使用和消耗的说明”）；
        <br />3.学员报名30日（含30日）以上不受理退费。
      </p>
      <!-- <h2>二、我们如何收集您的信息</h2> -->
      <br />
      <p class="title2">四、教学管理</p>
      <p>
        1.鉴于培训课程的特点，培训期间，甲方有权根据教学计划和进度对课程和考试的安排进行重新调整、修改并通知学员；设定职业能力等级评价的形式及内容，在做出变更评价形式及内容后通知学员。
        <br />2.学员需努力掌握培训的相关知识，按甲方提示的进度完成课程学习，配合作业或实训内容以达到培训的目的。
        <br />3.学员应服从甲方教务管理人员的学习安排，遵守甲方的各项教学及平台使用的管理制度。
        <br />4.学员需执行保密制度，不得将培训期间所学课程的内容、账号密码等外泄或传播第三方；不得私自录制、传播培训课程内容。
        <br />5.学员应真实、完整地填写入学申请表上所需的各项内容。个人资料如有变动，请及时主动与甲方联系，未及时联系所产生的不良后果由学员自行承担。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "contractTwo",
  data:() => {
      return{

      }
  },
  methods:{
      closeContract(){
          this.$emit('isShowContract',false)
      }
  }
};
</script>

<style lang="stylus" scoped>
.privacy{
    position:fixed;
    display:flex;
    height:100vh;
    flex-direction: column;
    z-index:10
}
.privacy-box {
  padding 100px 30px 30px 30px;
  background #F7F7F7;
  flex:1;
  overflow-y:scroll;
}
.head {
  position:fixed;
  width: 100%;
  height: 100px;
  background: #ffffff;
  text-align: center;
}
.title {
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 100px;
}
.black_arrow {
  position: absolute;
  left: 30px;
  top: 50%;
  transform:translateY(-50%);
}

.privacy-box h1, .privacy-box h2 {
  font-size: 0.96rem;
  text-align: center;
  padding: 1.6rem 0 0.64rem;
  line-height: 1.3rem;
}

.privacy-box h2 {
  text-align: left;
}

.privacy-box p {
  font-size: 0.746rem;
  color: #666;
  line-height: 1.6rem;
  text-align: justify;
  /* text-indent: 30px; */
}

.privacy-box .yinyan {
  text-align: center;
}

.privacy-box .title2 {
  font-weight: bold;
  color: #000;
  text-indent: 0px;
}
</style>>
